import * as React from 'react';
import EmployeesComboboxMI, { IEmployeesFilterParams, OptionType } from '../EmployeesComboboxMI';
import { IconButton, Icon, makeStyles } from '@material-ui/core';
import { IGridResourcesConfig } from './GridResourcesConfig';
import { useTranslation } from 'react-i18next';

interface IEmployeesFormProps {

	employeesFilters: IEmployeesFilterParams,

	value: OptionType,
	onChange: (v: OptionType) => void,

	blockChange: boolean,
	placeholderText: string,

	buttons: JSX.Element,
	grid: IGridResourcesConfig,
}

const useStyles = makeStyles((theme) => ({
	row: {
		display: "flex",
		alignItems: "center",
		marginBottom: "7px"
	},
	input: {
		flex: "1",
	},
	actions: {
		textAlign: "left",
	},
}));

function EmployeesForm(props: IEmployeesFormProps)
{
	return <div className="employee-info-content">
		{!props.blockChange && <div className="employee-info-input">
			<EmployeesComboboxMI
				filters={props.employeesFilters}
				value={props.value}
				onSelect={(v) => props.onChange(v)}
				placeholderText={props.placeholderText}
				grid={props.grid}
			/>
		</div>}
		{props.blockChange && <div className="employee-info-input">
			{props.value?.label}
		</div>}
		{props.buttons}
	</div>
}

interface IProps {
	blockChangeEmployees: boolean,
	employeesFilters: IEmployeesFilterParams,
	value: OptionType[],
	onChange: (v: OptionType[]) => void,

	multiple: boolean,
	placeholderText: string,

	getButtons: (value: OptionType) => JSX.Element,
	grid: IGridResourcesConfig,
}

export default function MultiEmployeesForm(props: IProps) {

	const classes = useStyles();
	const { t } = useTranslation();
	let blockChange = props.blockChangeEmployees && props.value.length != 0;

	function handleEmployeeChange(i: number, value: OptionType) {
		let copy = [...props.value];
		copy[i] = value;
		props.onChange(copy);
	}

	function handleAddClick() {
		let copy = [...props.value];
		copy.push(null);
		props.onChange(copy);
	}

	function handleDeleteClick(i: number) {
		let copy = [...props.value];
		copy.splice(i, 1);
		props.onChange(copy);
	}
	let nullButtons = null;
	if (props.getButtons && props.value.length === 0) {
		nullButtons = props.getButtons(null)
	}

	return <>
		{props.value.length === 0 && <>
			<EmployeesForm
				value={null}
				blockChange={blockChange}
				employeesFilters={props.employeesFilters}
				onChange={(v) => handleEmployeeChange(0, v)}
				placeholderText={props.placeholderText}
				buttons={nullButtons}
				grid={props.grid}
			/>
		</>}
		{props.value.map((selectedEmploye, i) => {

			let buttons = null;
			if (props.getButtons) {
				buttons = props.getButtons(selectedEmploye)
			}

			return <div className={"multi-employees-row " + classes.row} key={i}>
				<div className={"multi-employees-input " + classes.input}>
					<EmployeesForm
						value={selectedEmploye}
						onChange={(v) => handleEmployeeChange(i, v)}

						blockChange={blockChange}
						employeesFilters={props.employeesFilters}
						placeholderText={props.placeholderText}
						buttons={buttons}
						grid={props.grid}
					/>
				</div>
				{(props.multiple && !blockChange && props.value.length > 1) && <div className={"multi-employees-row-actions"}>
					<IconButton title={t("muiliEmployeesForm.deletePerson")} size="small" onClick={() => handleDeleteClick(i)}>
						<Icon>clear</Icon>
					</IconButton>
				</div>}
			</div>
		})}

		{props.multiple && !blockChange && <div className={"multi-employees-actions " + classes.actions}>
			<button type="button" title={t("muiliEmployeesForm.addPerson")} className="qd-btn qd-btn-default" onClick={handleAddClick}>+ {t("common.action.add")}</button>
		</div>}
	</>
}